import {
    Card,
    CardContent,
    Grid,
    makeStyles,
    Typography
} from "@material-ui/core";
import { useContext } from "react";
import { Loading, Title } from "react-admin";

import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";
import { ProfileChangePassword } from "./change-password.component";
import PreferredThemesCard from "./preferred-themes.component";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        width: '50%',
        marginLeft: '25%'
    },

    card: {
        height: "100%"
    },

    cardTitle: {
        fontSize: "1.1rem",
        fontWeight: 500,
        marginBottom: theme.spacing(2)
    },

    field: {
        marginBottom: theme.spacing(2)
    },

    label: {
        fontSize: "0.8rem",
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5)
    },

    value: {
        fontSize: "1rem",
        color: theme.palette.text.primary
    },

    contextBadge: {
        marginLeft: theme.spacing(1)
    },

    contextRow: {
        padding: theme.spacing(2, 0)
    },

    contextRowFirst: {
        paddingTop: 0
    },

    contextRowLast: {
        paddingBottom: 0
    },

    emptyState: {
        color: theme.palette.text.secondary,
        fontSize: "0.9rem"
    },

    securityContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    }
}));

const UserPage = () => {
    const classes = useStyles();
    const appContext = useContext(AppContext);
    const user = appContext.currentUser;

    const teacher = isTeacher(appContext)

    if (!user) {
        return <Loading />;
    }

    return (
        <Grid container spacing={3} className={classes.root}>
            <Title title="Meu perfil" />

            <Grid item xs={12}>
                <PageHeader />
            </Grid>

            <Grid item xs={12} md={6}>
                <UserInfoCard user={user} />
            </Grid>

            <Grid item xs={12} md={6}>
                <CurrentContextCard
                    context={appContext}
                />
            </Grid>

            <Grid item xs={12}>
                <SecurityCard user={user} />
            </Grid>

            {teacher && (
                <Grid item xs={12}>
                    <PreferredThemesCard
                        context={appContext.currentUserContext}
                    />
                </Grid>
            )}

        </Grid>
    );
};

const PageHeader = () => {
    return (
        <div>
            <Typography variant="h5">
                Meu perfil
            </Typography>

            <Typography variant="body2" color="textSecondary">
                Visualize suas informações, contexto de acesso e preferências.
            </Typography>
        </div>
    );
};

const UserInfoCard = ({ user }) => {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardContent>
                <Typography className={classes.cardTitle}>
                    Dados pessoais
                </Typography>

                <InfoField
                    label="Nome"
                    value={user.name}
                />

                <InfoField
                    label="E-mail"
                    value={user.email}
                />

                {user.phone && (
                    <InfoField
                        label="Telefone"
                        value={user.phone}
                    />
                )}
            </CardContent>
        </Card>
    );
};

const CurrentContextCard = ({ context }) => {
    const classes = useStyles();

    if (!context) {
        return null;
    }

    return (
        <Card className={classes.card}>
            <CardContent>
                <Typography className={classes.cardTitle}>
                    Contexto atual
                </Typography>

                <InfoField
                    label="Instituição"
                    value={context.institutionBranch?.institution?.name}
                />

                <InfoField
                    label="Unidade"
                    value={context.institutionBranch?.name}
                />

                <InfoField
                    label="Perfil"
                    value={context.profile?.name}
                />
            </CardContent>
        </Card>
    );
};

const SecurityCard = ({ user }) => {
    const classes = useStyles();

    return (
        <Card>
            <CardContent>
                <Typography className={classes.cardTitle}>
                    Segurança
                </Typography>

                <div className={classes.securityContent}>
                    <Typography variant="body2" color="textSecondary">
                        Altere a senha utilizada para acessar o sistema.
                    </Typography>

                    <ProfileChangePassword user={user} />
                </div>
            </CardContent>
        </Card>
    );
};

const InfoField = ({ label, value }) => {
    const classes = useStyles();

    return (
        <div className={classes.field}>
            <Typography className={classes.label}>
                {label}
            </Typography>

            <Typography className={classes.value}>
                {value || "-"}
            </Typography>
        </div>
    );
};

const isTeacher = (context) => {
    return context?.profile?.name === ProfileEnum.TEACHER;
};

export default UserPage;